import { ROUTE_PARAM } from '@constants'
import Dashboard from '@dashboard/views/Dashboard'
import { paths } from 'mmfintech-backend-api'
import type { RouteDefinition } from 'mmfintech-backend-api/types'
import React from 'react'

const LazyDeposit = React.lazy(() => import('@banking/views/Deposit'))
const LazyExchange = React.lazy(() => import('@banking/views/Exchange'))
const LazyInvoices = React.lazy(() => import('@invoices/views/Invoices'))
const LazyWithdraw = React.lazy(() => import('@banking/views/SendMoney'))
const LazyInvoiceEdit = React.lazy(() => import('@invoices/views/InvoiceEdit'))
const LazyTransactions = React.lazy(() => import('@transactions/views/Transactions'))
const LazyInvoiceUpload = React.lazy(() => import('@invoices/views/InvoiceUploadEdit'))
const LazyOnboarding = React.lazy(() => import('@onboarding/views/SumSubVerification'))

// prettier-ignore
export const protectedRoutes: RouteDefinition[] = [
  { path: paths.root(), redirect: paths.dashboard() },

  { path: paths.dashboard(), component: Dashboard },
  { path: paths.profile(), component: React.lazy(() => import('@settings/views/Profile')) },
  { path: paths.security(), component: React.lazy(() => import('@settings/views/Security')) },
  { path: paths.developer(), component: React.lazy(() => import('@developer/views/Developer')) },
  { path: paths.userManagement(), component: React.lazy(() => import('@users/views/Users')) },
  { path: paths.referralProgram(), component: React.lazy(() => import('@referral/views/ReferralProgram')) },

  { path: paths.onboarding.documents(), component: React.lazy(() => import('@onboarding/views/AdditionalDocuments')) },
  {
    path: paths.onboarding.selectType(),
    component: React.lazy(() => import('@onboarding/views/SelectOnboardingType'))
  },
  {
    path: paths.onboarding.questionnaireKyb(),
    component: React.lazy(() => import('@onboarding/views/QuestionnaireKYB'))
  },
  {
    path: paths.onboarding.questionnaireKybSuccess(),
    component: React.lazy(() => import('@onboarding/views/QuestionnaireSuccess'))
  },
  { path: `${paths.onboarding.continueOnboarding()}/${ROUTE_PARAM.MERCHANT_TYPE}`, component: LazyOnboarding },
  { path: paths.onboarding.continueOnboarding(), component: LazyOnboarding },

  { path: paths.banking.accounts.list(), component: React.lazy(() => import('@accounts/views/Accounts')) },

  {
    path: paths.banking.transactions.details(ROUTE_PARAM.TRANSACTION_ID),
    component: React.lazy(() => import('@transactions/views/TransactionDetails'))
  },
  { path: paths.banking.transactions.listByAccountId(ROUTE_PARAM.ACCOUNT_ID), component: LazyTransactions },
  { path: paths.banking.transactions.list(), component: LazyTransactions },

  {
    path: paths.banking.depositPreview(),
    component: React.lazy(() => import('@banking/views/ApplicationFeePreview'))
  },
  { path: paths.banking.depositByAccountId(ROUTE_PARAM.ACCOUNT_ID), component: LazyDeposit },
  { path: paths.banking.deposit(), component: LazyDeposit },
  { path: paths.banking.exchangeFromTo(ROUTE_PARAM.FROM_CURRENCY, ROUTE_PARAM.TO_CURRENCY), component: LazyExchange },
  { path: paths.banking.exchange(), component: LazyExchange },
  { path: paths.banking.sendCrypto(), component: React.lazy(() => import('@banking/views/CryptoTransfer')) },
  { path: paths.banking.sendTransfer(), component: React.lazy(() => import('@banking/views/InternalTransfer')) },
  { path: paths.banking.sendBankTransfer(), component: React.lazy(() => import('@withdraw/views/BankTransfer')) },
  {
    path: paths.banking.sendDigitalWallet(),
    component: React.lazy(() => import('@banking/views/WalletTransfer/JetonWalletTransfer'))
  },
  {
    path: paths.banking.sendJetonWallet(),
    component: React.lazy(() => import('@banking/views/WalletTransfer/JetonWalletTransfer'))
  },
  {
    path: paths.banking.sendKingdomWallet(),
    component: React.lazy(() => import('@banking/views/WalletTransfer/KingdomWalletTransfer'))
  },
  {
    path: paths.banking.sendIntraAccountTransfer(),
    component: React.lazy(() => import('@banking/views/IntraAccountTransfer'))
  },
  { path: paths.banking.sendTo(ROUTE_PARAM.RECIPIENT_ID), component: LazyWithdraw },
  { path: paths.banking.send(), component: LazyWithdraw },

  { path: paths.banking.expenses(), component: React.lazy(() => import('@requests/views/Requests')) },

  {
    path: paths.recipients.details(ROUTE_PARAM.RECIPIENT_ID),
    component: React.lazy(() => import('@recipients/views/RecipientDetails'))
  },
  { path: paths.recipients.list(), component: React.lazy(() => import('@recipients/views/Recipients')) },

  {
    path: paths.customerInvoices(ROUTE_PARAM.PAYER_ID),
    component: React.lazy(() => import('@customers/views/CustomerInvoices'))
  },
  { path: paths.customers(), component: React.lazy(() => import('@customers/views/Customers')) },

  { path: paths.invoices.uploadEdit(ROUTE_PARAM.INVOICE_ID), component: LazyInvoiceUpload },
  { path: paths.invoices.upload(), component: LazyInvoiceUpload },
  { path: paths.invoices.addForCustomer(ROUTE_PARAM.CUSTOMER_ID), component: LazyInvoiceEdit },
  { path: paths.invoices.add(), component: LazyInvoiceEdit },
  {
    path: paths.invoices.send(ROUTE_PARAM.INVOICE_ID),
    component: React.lazy(() => import('@invoices/views/InvoiceSend'))
  },
  { path: paths.invoices.edit(ROUTE_PARAM.INVOICE_ID), component: LazyInvoiceEdit },
  { path: paths.invoices.listByStatus(ROUTE_PARAM.STATUS), component: LazyInvoices },
  { path: paths.invoices.list(), component: LazyInvoices }
]
